import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-wtn-point',
    templateUrl: './wtn-point.component.html',
    styleUrls: ['./wtn-point.component.scss'],
})
export class WtnPointComponent implements OnInit {
    @Input() point: string;
    @Input() tooltip: string;
    constructor() {}

    ngOnInit(): void {}
}
